import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ratio-toggle',
    template: `
        <ham-button
            *ngIf="active && available; else inactiveBtn"
            variant="primary"
            [disabled]="!available"
            [title]="'aumico_analytics_controls_struct_mode_tooltip' | i18next"
            (buttonClick)="toggle.emit()">
            {{ 'aumico_analytics_controls_struct_mode' | i18next }}
        </ham-button>
        <ng-template #inactiveBtn>
            <ham-button
                variant="white"
                outline="true"
                [disabled]="!available"
                [title]="(available ? 'aumico_analytics_controls_struct_mode_tooltip'
                                    : 'aumico_analytics_controls_struct_mode_no_reference_tooltip') | i18next"
                (buttonClick)="toggle.emit()">
                {{ 'aumico_analytics_controls_struct_mode' | i18next }}
            </ham-button>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatioToggleComponent {
    @Input() public active = false;
    @Input() public available = true;
    @Output() public toggle = new EventEmitter<void>();
}
